export default __webpack_public_path__ + "static/media/Hive Bludgeon.4437dd61.jpg";